export function convertBrToP(htmlContent) {
    // Replace all <br> tags with </p><p>
    const replacedContent = htmlContent.replace(/<br\s*[/]?>/gi, '</p><p>');
      
    // Wrap the content with <p> tags
    let wrappedContent = `${replacedContent}`;
  
    return wrappedContent;
  }  

export const extractFAQFromHTML = (html) => {
  if (!html) return [];
  if (typeof window === "undefined") return []; // SSR safety

  const parser = new window.DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const questions = Array.from(doc.querySelectorAll(".question"));
  const answers = Array.from(doc.querySelectorAll(".answer"));

  return questions.map((q, i) => ({
    question: q.textContent.trim(),
    answer: answers[i]?.textContent.trim() || ""
  }));
};

export function removeEmptyHeadings(htmlContent) {
  if (!htmlContent || typeof htmlContent !== "string") return htmlContent;
  return htmlContent.replace(/<h([1-6])[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/h\1>/gi, '');
}


